/* Mia custom cart: timer, segmented tier rewards (by item count), upsell carousel, remove, checkout total */
(function () {
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var TIERS = [
    { count: 2, before: 'You are {COUNT} away from getting a 15% discount.' },
    { count: 3, before: 'You need {COUNT} more to get a 20% discount.' },
    { count: 4, before: 'You need {COUNT} more to get a 25% discount.' }
  ];
  var AFTER = 'Congratulations, you unlocked a 25% discount!';
  var TIMER_SECONDS = 600;
  var HIDDEN_HANDLES = ['shipping-protection'];

  function money(cents) {
    return (window.theme && theme.Currency && theme.Currency.formatMoney)
      ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
      : '$' + (cents / 100).toFixed(2);
  }

  function json(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw data;
      return data;
    });
  }

  /* Timer: "Your cart is reserved for 10:00" */
  var timerEl = drawer.querySelector('[data-mia-timer]');
  function timerStart() {
    var start;
    try { start = parseInt(sessionStorage.getItem('miaCartTimer'), 10); } catch (e) {}
    if (!start || Date.now() - start > TIMER_SECONDS * 1000) {
      start = Date.now();
      try { sessionStorage.setItem('miaCartTimer', String(start)); } catch (e) {}
    }
    return start;
  }
  function tick() {
    if (!timerEl) return;
    var left = Math.max(0, TIMER_SECONDS - Math.floor((Date.now() - timerStart()) / 1000));
    var m = Math.floor(left / 60), s = left % 60;
    timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  tick();
  setInterval(tick, 1000);

  /* Upsell carousel: one card per view, arrows loop, swipe on touch, drag with the mouse */
  var row = drawer.querySelector('[data-mia-row]');
  var arrows = drawer.querySelectorAll('[data-mia-arrow]');

  function cards() {
    return row ? [].filter.call(row.children, function (c) { return !c.hidden; }) : [];
  }
  function currentIndex() {
    var list = cards(), best = 0;
    list.forEach(function (c, i) {
      if (Math.abs(c.offsetLeft - row.scrollLeft) < Math.abs(list[best].offsetLeft - row.scrollLeft)) best = i;
    });
    return best;
  }
  function goTo(i, smooth) {
    var list = cards();
    if (!list.length) return;
    i = (i + list.length) % list.length;
    row.scrollTo({ left: list[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function syncCarousel() {
    if (!row) return;
    var many = cards().length > 1;
    [].forEach.call(arrows, function (a) { a.hidden = !many; });
    goTo(Math.min(currentIndex(), cards().length - 1), false);
  }

  if (row) {
    var drag = null, swallowClick = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('select, button, input')) return;
      drag = { x: e.clientX, left: row.scrollLeft, index: currentIndex(), moved: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved && Math.abs(dx) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        row.classList.add('is-dragging');
      }
      row.scrollLeft = drag.left - dx;
    });
    window.addEventListener('pointerup', function (e) {
      if (!drag) return;
      var d = drag, dx = e.clientX - d.x;
      drag = null;
      if (!d.moved) return;
      /* a short flick is enough to move one card */
      goTo(Math.abs(dx) > 40 ? d.index + (dx < 0 ? 1 : -1) : d.index);
      setTimeout(function () { row.classList.remove('is-dragging'); }, 450);
      swallowClick = true;
      setTimeout(function () { swallowClick = false; }, 0);
    });
    row.addEventListener('click', function (e) {
      if (!swallowClick) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function render(cart) {
    var count = 0;
    cart.items.forEach(function (i) { if (HIDDEN_HANDLES.indexOf(i.handle) === -1) count += i.quantity; });

    drawer.classList.toggle('is-empty', cart.item_count === 0);
    var countEl = drawer.querySelector('[data-mia-count]');
    if (countEl) countEl.textContent = count;
    var totalEl = drawer.querySelector('[data-mia-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);

    /* Segmented bar: segment i fills from previous tier count to tier i count */
    var rewards = drawer.querySelector('[data-mia-rewards]');
    if (rewards) {
      rewards.hidden = count === 0;
      var next = null, prev = 0;
      TIERS.forEach(function (t, i) {
        var seg = drawer.querySelector('[data-mia-seg="' + i + '"]');
        var pct = count >= t.count ? 100 : (count <= prev ? 0 : ((count - prev) / (t.count - prev)) * 100);
        if (seg) seg.style.width = pct + '%';
        if (!next && count < t.count) next = t;
        prev = t.count;
      });
      drawer.querySelector('[data-mia-rewards-text]').textContent = next ? next.before.replace('{COUNT}', next.count - count) : AFTER;
      drawer.querySelectorAll('[data-mia-tier]').forEach(function (el) {
        el.classList.toggle('is-complete', count >= parseInt(el.getAttribute('data-mia-tier'), 10));
      });
    }

    var inCart = cart.items.map(function (i) { return String(i.product_id); });
    var shown = 0;
    drawer.querySelectorAll('.mia-cart__upsell').forEach(function (el) {
      var hide = inCart.indexOf(el.getAttribute('data-product-id')) !== -1;
      el.hidden = hide;
      if (!hide) shown++;
    });
    var ups = drawer.querySelector('[data-mia-upsells]');
    if (ups) ups.hidden = shown === 0 || count === 0;
    syncCarousel();
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(json)
      .then(render)
      .catch(function () {});
  }

  function rebuild() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    refresh();
  }

  /* Impulse replaces [data-products] on every change */
  var products = drawer.querySelector('[data-products]');
  if (products && window.MutationObserver) {
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 50);
    }).observe(products, { childList: true });
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) render(e.detail.cart); else refresh();
  });
  document.addEventListener('ajaxProduct:added', refresh);

  /* Variant picker on an upsell: add the chosen variant and show its price */
  drawer.addEventListener('change', function (e) {
    if (!e.target.classList.contains('mia-cart__upsell-variant')) return;
    var card = e.target.closest('.mia-cart__upsell');
    var opt = e.target.options[e.target.selectedIndex];
    var add = card.querySelector('.mia-cart__upsell-add');
    add.setAttribute('data-variant-id', e.target.value);
    add.disabled = false;
    add.textContent = 'Add';
    var price = card.querySelector('[data-mia-price]');
    var compare = card.querySelector('[data-mia-compare]');
    if (price && opt.getAttribute('data-price')) price.textContent = opt.getAttribute('data-price');
    if (compare) {
      compare.textContent = opt.getAttribute('data-compare') || '';
      compare.hidden = !opt.getAttribute('data-compare');
    }
  });

  drawer.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-mia-arrow]');
    if (arrow) {
      e.preventDefault();
      goTo(currentIndex() + parseInt(arrow.getAttribute('data-mia-arrow'), 10));
      return;
    }

    if (e.target.closest('[data-mia-close]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:close'));
      return;
    }

    var rm = e.target.closest('[data-mia-remove]');
    if (rm) {
      e.preventDefault();
      if (rm.disabled) return;
      rm.disabled = true;
      var item = rm.closest('.mia-item');
      if (item) item.classList.add('is-removing');
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: rm.getAttribute('data-mia-remove'), quantity: 0 })
      })
        .then(json)
        .then(function (cart) {
          drawer.classList.toggle('is-empty', cart.item_count === 0);
          rebuild();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {
          rm.disabled = false;
          if (item) item.classList.remove('is-removing');
        });
      return;
    }

    var btn = e.target.closest('.mia-cart__upsell-add');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }] })
    })
      .then(json)
      .then(function () {
        btn.textContent = 'Added';
        rebuild();
        setTimeout(function () {
          btn.disabled = false;
          btn.textContent = 'Add';
        }, 1500);
      })
      .catch(function (err) {
        var soldOut = err && err.status === 422;
        btn.textContent = soldOut ? 'Sold out' : 'Add';
        btn.disabled = soldOut;
      });
  });

  refresh();
})();
